export const APP_CONFIG = {
  appName: 'Valley Health Benefits',
  frontend: 'https://valleyhealthbenefits.com',
  apiHash: 'https://valleyhealthbenefits.com/api/1.0',
  api: '/api/2.0',
  trustModel: false,
  commitSHA: '1664030',
  authHeaders: {
    xServiceProvider: 'valleyhealth-frontend',
    'tenant-id': '990cf75b-cf4f-4838-87a6-05339efc3ba6',
    'consumer-id': 'd5274569-539b-4c53-999c-8e2bff3eccb7',
  },
  provider: 'valleyhealth-frontend',
  colors: {
    primary: '#326295',
    secondary: '#9999cc',
  },
  multilingual: true,
  demoMode: false,
  contactEnabled: true,
  benefitCategories: true,
  imagery: {
    logo: 'https://storage.googleapis.com/archipelago-assets/valley-health/logo.png',
    logoInverted:'https://storage.googleapis.com/archipelago-assets/valley-health/logo.png',
    logoTransparent:'https://storage.googleapis.com/archipelago-assets/valley-health/logo.png',
  },
  gtm: 'GTM-KVHSWDK',
  copyright: '<small>&copy; ' + new Date().getFullYear() +
      ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'solid',
    categoryNav: true
  },
  coreLinkify: true,
  enableSSR: false,
cookiePolicy: '2e3d8b82',
};

